<div class="container-fluid download-bg">
    <div class="row">
        <div class="col-md-12">
            <div class="download-top">
                <div class="row m-0">
                    <div class="col-md-2 col-sm-3 p-0 d-flex justify-content-center align-items-center">
                        <h3>Downloads</h3>
                    </div>
                    <div class="col-md-10 col-sm-9">
                        <div class="download-input">
                            <button class="btn-style-remove download-search p-0">
                                <i class="fa fa-search"></i>
                            </button>
                            <input type="text" placeholder="Search Suppliers" (keyup)="onSearchVendor($event)" />
                            <button class="btn-style-remove download-close p-0" (click)="clearSearch()">
                                <i class="fa fa-close"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">Update Date</th>
                            <th scope="col" class="text-center">Last Edit</th>
                            <th scope="col">Supplier</th>
                            <th scope="col" class="text-center">File Type</th>
                            <th scope="col" class="text-right">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let download of vendorDownloadList">
                            <td class="text-center">{{ download.upload_date | date}}</td>
                            <td class="text-center">{{ download.last_edit_date | date}}</td>
                            <td class="text-center">{{ download.business_name }}</td>
                            <td class="text-center">CSV</td>
                            <td class="text-right">
                                <!-- <a href="#"> New File</a> -->
                                <button class="downbtn" (click)="downloadCSVFile(download.vendor_id)">Download</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
